import { render } from "./Navbar.vue?vue&type=template&id=02492466"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ianlueninghoener/Documents/development/ianlueninghoener.com/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])